import * as _ from 'underscore';

import { Module } from '../Module';

interface UIRouterInternalState {
  includes: _.Dictionary<boolean>;
  url: ng.ui.IUrlMatcher;
}

export interface IStateAndStateParams {
  state: ng.ui.IState;
  params: any;
}

/**
 * Facade on ui-router's $state
 * Use this when you're trying to learn things about a state that is not the current state, otherwise use $state directly.
 */
export class StateWrapperService {

  public static $inject = ['$state'];

  constructor(private $state: ng.ui.IStateService) {
  }

  private t(state: ng.ui.IState): UIRouterInternalState {
    return <UIRouterInternalState> (<any> state).$$state;
  }

  /**
   * Returns the first state found that matches the path and the search parameters.
   * If no state is found, returns undefined
   * Normal usage: getMatchingState($location.path(), $location.search())
   */
  public getMatchingState(path: string, searchParams: {}): ng.ui.IState {
    return _.find(this.$state.get(), (state: ng.ui.IState) => {
      const internalState = this.t(state);
      return internalState && internalState.url &&
        !!internalState.url.exec(path, searchParams);
    });
  }

  /**
   * Return the stateParams that match the path and the searchParams.
   * If no state is found, returns undefined
   * Normal usage: getStateParams($location.path(), $location.search())
   */
  public getStateParams(path: string, searchParams: {}): {} {
    const state = this.getMatchingState(path, searchParams);
    if (!state) return undefined;
    return this.t(state).url.exec(path, searchParams);
  }

  /**
   * Gets the site urlName from the current url if it is the login state
   */
  public getSiteUrlNameIfLoginState(path: string, searchParams: {}): string {
    const state = this.getMatchingState(path, searchParams);
    if (!state) return null;
    const stateParams: any = this.t(state).url.exec(path, searchParams);
    if (state.name === 'login.authenticate') {
      return stateParams['site'];
    }
    return null;
  }

  public isDescendantOf(descendant: ng.ui.IState, ancestorName: string) {
    if (!descendant) return undefined;
    return this.t(descendant).includes[ancestorName] && descendant.name !== ancestorName;
  }

}

Module.instance().service('StateWrapperService', StateWrapperService);
